import { usePurchaseOrderContractTask } from '@/hooks/api/0820_purchase_order_contract_task';
import { TeamMemberLogic } from '@/hooks/api/models/logics';
import { toastError } from '@/lib/toast';
import { useCurrentPurchaseOrderContractTask } from '@/providers/PurchaseOrderContractTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

type Props = { children?: React.ReactNode };

export const RequirePurchaseOrderContractTask = (props: Props) => {
  const location = useLocation();
  const { me, meTeamMember } = useCurrentTeamMember();
  const { identifier, team_id, purchase_order_id, purchase_order_contract_task_id } = useParams();
  const { data, status } = usePurchaseOrderContractTask({
    identifier: identifier!,
    team_id: Number(team_id!),
    purchase_order_id: Number(purchase_order_id!),
    id: Number(purchase_order_contract_task_id!),
  });
  const { purchaseOrderContractTask, setPurchaseOrderContractTask } = useCurrentPurchaseOrderContractTask();

  useEffect(() => {
    if (data) {
      setPurchaseOrderContractTask((_) => data);
    }
  }, [data]);

  if (status == 'error') {
    toastError('アクセス出来ませんでした。');
    return <Navigate replace to={`/w/${identifier}`} />;
  }

  // backoffice権限のみの場合
  if (meTeamMember && TeamMemberLogic.hasBackofficeOnlyRole(meTeamMember!)) {
    // urlがプロジェクト配下のurlの場合は、backoffice配下のurlに遷移
    if (location.pathname.startsWith(`/w/${identifier}/teams/`)) {
      return (
        <Navigate
          replace
          to={`/w/${identifier}/backoffice/teams/${team_id}/purchase_orders/${purchase_order_id}/purchase_order_contract_tasks/${purchase_order_contract_task_id}`}
        />
      );
    }
  }

  if (purchaseOrderContractTask) {
    return <>{props.children}</>;
  }

  return <></>;
};
